import { SegmentPropertyValue } from '@/integrations/segment/enums/SegmentPropertyValue';
import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { SelfServeSignupPageViewedEventTracking } from '@/modules/auth/models/segmentevents/SelfServeSignupPageViewedEventTracking';
import { BillingPlanId } from '@/modules/billing/constants/BillingPlanId';

export class SelfServeSignupPageCompletedEventTracking extends SelfServeSignupPageViewedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.SELF_SERVE_SIGNUP_PAGE_COMPLETED;
  billing_plan: BillingPlanId;
  standard_plan_flow: SegmentPropertyValue;
  onboarding_completed: boolean;
  line_of_business?: string;

  constructor(eventProperties: Partial<SelfServeSignupPageCompletedEventTracking> = {}) {
    super(eventProperties);
    this.billing_plan = eventProperties.billing_plan!;
    this.standard_plan_flow = SegmentPropertyValue.STARTED;
    this.onboarding_completed = false;
    this.line_of_business = eventProperties?.line_of_business;
  }
}
